var _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30",
    fill: "none",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3C19.538 3 22 5.5 22 9C22 16 12 21 12 21C12 21 2 16 2 9C2 5.5 4.5 3 7.5 3C9.36 3 11 4 12 5C13 4 14.64 3 16.5 3Z",
    fill: "black"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 39,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Cetha Studio")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 44,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullHeart);
export default __webpack_public_path__ + "static/media/full-heart.7cee84e26b15a4b16229860bceb993ff.svg";
export { ForwardRef as ReactComponent };